import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { actors, getFilmography } from "@/lib/media";

export default function ActorsStrip() {
  const list = actors.slice(0, 4);

  return (
    <section className="shell mt-12 md:mt-16" aria-label="演员档案">
      <SectionHeading
        eyebrow="Profiles"
        title="演员档案"
        desc="从角色回到演员本人，看看他们如何准备一个镜头"
        moreTo="/category/all"
        moreLabel="从作品里找演员"
      />

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {list.map((actor) => {
          const works = getFilmography(actor.id);
          return (
            <Link
              key={actor.id}
              to={`/actor/${actor.id}`}
              className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="aspect-[4/5] w-full overflow-hidden bg-secondary-100">
                <img
                  src={actor.avatar}
                  alt={`${actor.name} 头像`}
                  title={`${actor.name} 演员资料`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="p-3">
                <div className="flex items-baseline gap-1.5">
                  <h3 className="text-sm font-bold text-foreground-950 group-hover:text-primary-700">{actor.name}</h3>
                  <span className="font-label text-[10px] uppercase tracking-[0.12em] text-foreground-400">
                    {actor.enName.split(" ")[0]}
                  </span>
                </div>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{actor.tags.join(" · ")}</p>
                <p className="mt-2 flex items-center gap-1 text-[11px] text-foreground-400">
                  <i className="ri-film-line" />
                  参演 {works.length} 部作品
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}